import { render } from "./Informacion.vue?vue&type=template&id=01e94e6d"
import script from "./Informacion.vue?vue&type=script&lang=js"
export * from "./Informacion.vue?vue&type=script&lang=js"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__